"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import YearRangeSlider from "@/components/ui/YearRangeSlider";
interface RangeSelectBoxProps {
  title: string;
  min: number;
  max: number;
  step?: number;
  value?: [number, number];
  onChange?: (range: [number, number]) => void;
  onFinalChange?: (range: [number, number]) => void;
}
export default function RangeSelectBox(t0) {
  const $ = _c(24);
  const {
    title,
    min,
    max,
    step: t1,
    value,
    onChange,
    onFinalChange
  } = t0;
  const step = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== max || $[1] !== min || $[2] !== value) {
    t2 = value ?? [min, max];
    $[0] = max;
    $[1] = min;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [selectedRange, setSelectedRange] = useState(t2);
  let t3;
  if ($[4] !== title) {
    t3 = <label className="text-sm font-medium">{title}</label>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onChange) {
    t4 = r => {
      setSelectedRange(r);
      onChange?.(r);
    };
    $[6] = onChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onFinalChange) {
    t5 = r_0 => onFinalChange?.(r_0);
    $[8] = onFinalChange;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== max || $[11] !== min || $[12] !== selectedRange || $[13] !== step || $[14] !== t4 || $[15] !== t5) {
    t6 = <YearRangeSlider value={selectedRange} min={min} max={max} step={step} onChange={t4} onFinalChange={t5} />;
    $[10] = max;
    $[11] = min;
    $[12] = selectedRange;
    $[13] = step;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== selectedRange[0] || $[18] !== selectedRange[1]) {
    t7 = selectedRange[1] !== 0 && selectedRange[0] !== 0 && <div className="flex justify-between text-xs text-gray-500"><span>{selectedRange[1]}</span><span>{selectedRange[0]}</span></div>;
    $[17] = selectedRange[0];
    $[18] = selectedRange[1];
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t3 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className="w-full flex flex-col gap-2">{t3}{t6}{t7}</div>;
    $[20] = t3;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}